interface Request {
	amount: string;
	name: string;
	price: string;
}
export const productText = (req: Request): string => `${req.amount} x ${req.name}(${req.price})`;
